import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import classNames from 'classnames';
import ScheduleIcon from '@material-ui/icons/Schedule.js';

import {addressSource} from 'common/utils/addresses';
import CornerButton from 'ondemand/components/CornerButton';
import PlacesAutocomplete from 'common/components/PlacesAutocomplete';
import ArrowBackIcon from 'common/components/icons/ArrowBackIcon';
import styles from './RideRequestSearch.css';


class RideRequestSearch extends React.PureComponent {
  static displayName = 'RideRequestSearch';

  static propTypes = {
    addresses: PropTypes.arrayOf(PropTypes.object),
    disableGoogleSource: PropTypes.bool,
    onScheduleClick: PropTypes.func,
    onSuggestion: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (_.isString(nextProps.value) && nextProps.value !== prevState.origStateValue) {
      return {
        value: nextProps.value,
        origStateValue: nextProps.value,
      };
    }
    return {
      origStateValue: nextProps.value
    };
  }

  state = {
    isOpen: false,
    previousValue: '',
    origStateValue: this.props.value,
    value: '',
  };

  _handleArrowClick = () => {
    this.setState(({previousValue}) => ({
      isOpen: false,
      value: previousValue,
    }));
  };

  _handleChange = (event, {newValue}) => {
    this.setState({
      isOpen: true,
      value: newValue,
    });
  };

  _handleFocus = () => {
    this.setState((prevState) => ({
      isOpen: true,
      previousValue: prevState.value,
      value: '',
    }));
  };

  _handleSuggestion = (...args) => {
    this.setState({isOpen: false});
    this.props.onSuggestion(...args);
  };

  render() {
    return (
      <div
        className={classNames(styles.root, {
          [styles.open]: this.state.isOpen,
          [styles.schedule]: this.props.onScheduleClick,
        })}
      >
        {this.state.isOpen &&
          <CornerButton
            onClick={this._handleArrowClick}
            zIndex={10}
          >
            <ArrowBackIcon />
          </CornerButton>
        }
        <div className={styles.searchWrapper} data-id="ride-request-search">
          <PlacesAutocomplete
            alwaysRenderSuggestions={this.state.isOpen}
            disableGoogleSource={this.props.disableGoogleSource || false}
            focusFirstSuggestion
            focusInputOnSuggestionClick={false}
            onChange={this._handleChange}
            onFocus={this._handleFocus}
            onSuggestion={this._handleSuggestion}
            placeholder={this.state.previousValue || this.props.placeholder}
            sources={[
              addressSource(_.filter(this.props.addresses, (a) => a.type === 'rider')),
              addressSource(_.filter(this.props.addresses, (a) => a.type === 'agency')),
            ]}
            theme={this.props.onScheduleClick ? {input: styles.input} : null}
            value={this.state.isOpen ? this.state.value : this.props.value}
          />
          {this.props.onScheduleClick &&
            <div className={styles.scheduleIcon} data-id="edit-datetime-button">
              <ScheduleIcon
                color="primary"
                onClick={this.props.onScheduleClick}
                style={{width: 28, height: 28}}
              />
            </div>
          }
        </div>
      </div>
    );
  }
}

export default RideRequestSearch;



// WEBPACK FOOTER //
// ./src/ondemand/components/RideRequestSearch/RideRequestSearch.js